import store from "../../../store";
import tilda_export from './tilda_export.vue';

window.tilda_export =  new Vue({
    store,
    el: 'div#tilda_export',

    name : "tilda_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        tilda_export,
    }
});
